export var getAnchorElementFromEvent = function getAnchorElementFromEvent(evt) {
  var anchor = [evt.target, evt.currentTarget].find(function (targ) {
    return targ.nodeName === 'A';
  });
  return anchor && anchor;
};